<script>
  import { Label, Input } from "sveltestrap";
  import { downloadJSON, downloadHTML } from "../../editor/component/export.js";
  import {
    exportLocalStorageAsJSON,
    importFromJSON,
    viewSpecs,
    systemLog,
  } from "../../editor/storage.js";
  import { generateHTMLoutput } from "../../editor/makeHTML.js";
  import { firstLevelMenus } from "../../editor/menuSchema.js";

  // event functions
  export let inputFocusAction;
  export let inputBlurAction;

  let reader = new FileReader();
  reader.addEventListener("load", () => {
    let content = JSON.parse(reader.result);
    console.log(content);
    //todo: save to variables;
    importFromJSON(content);
    $systemLog.log({ message: "Imported from JSON" });
  });

  function processSpec(event) {
    let file = event.target.files[0];
    if (file.name.endsWith(".dupo.json")) {
      reader.readAsText(file);
    }
  }

  let subMenu;
  function setSubMenu(s) {
    subMenu = s;
  }
  function cancelSubMenu() {
    subMenu = undefined;
  }

  let export_file_name;
  function exportSpecs() {
    // get data from local storage
    // if there's problem with sync, fix it later
    exportLocalStorageAsJSON().then((JSONfromLocal) => {
      downloadJSON(JSONfromLocal, `${export_file_name || "export"}.dupo.json`);
    });
    $systemLog.log({ message: "Exported as JSON" });
  }
  function exportViews() {
    downloadHTML(
      generateHTMLoutput($viewSpecs),
      `${export_file_name || "export"}.html`
    );
    $systemLog.log({ message: "Exported as html" });
  }
</script>

{#if !subMenu}
  <h2>
    {firstLevelMenus["export"]?.title || "Export/Import"}
  </h2>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <p class="text-sm">Import or export files.</p>
    </div>
    <div class="dupo-menu-pane-form-row">
      <button
        class="menu-second-level"
        type="button"
        on:click={() => setSubMenu("import")}
        ><i class="bi bi-box-arrow-in-right me-1" /> Import</button
      >
    </div>
    <div class="dupo-menu-pane-form-row">
      <button
        class="menu-second-level"
        type="button"
        on:click={() => setSubMenu("export")}
        ><i class="bi bi-box-arrow-left me-1" /> Export</button
      >
    </div>
  </div>
{:else if subMenu === "import"}
  <div class="dupo-menu-pane mb-5 pt-3">
    <div class="dupo-menu-pane-row">
      <Label for="import">Import a Dupo file (<code>*.dupo.json</code>)</Label>
    </div>
    <div class="dupo-menu-pane-form-row">
      <Input
        type="file"
        name="import"
        id="import"
        class="custom-form-select"
        accept=".json"
        on:change={(event) => processSpec(event)}
      />
    </div>
    <div class="dupo-menu-pane-row description mt-2">
      <p class="text-sm">
        When importing a new file, the current cached data will be removed.
        Export the current data.
      </p>
    </div>
    <div class="dupo-menu-pane-button-row mt-2">
      <button type="button" on:click={() => setSubMenu("export")}
        >Cancel and export first</button
      >
      <button type="button" on:click={() => cancelSubMenu()}
        ><i class="bi bi-arrow-left me-1" />Cancel</button
      >
    </div>
  </div>
{:else if subMenu === "export"}
  <div class="dupo-menu-pane mb-2 mt-3">
    <div class="dupo-menu-pane-row">
      <p class="text-sm">Export specs or views</p>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <Label for="export_file_name">File name</Label>
    </div>
    <div class="dupo-menu-pane-form-row">
      <Input
        type="text"
        name="export_file_name"
        id="export_file_name"
        class="custom-form-select"
        autocomplete="off" 
        bind:value={export_file_name}
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
      />
    </div>
    <div class="dupo-menu-pane-row description mt-2">
      <p class="text-sm">
        If provided, this file name is used before the extensions. Otherwise,
        default file name (export.*) is used.
      </p>
    </div>
    <div class="dupo-menu-pane-form-row mt-2">
      <button
        type="button"
        class="menu-second-level"
        on:click={() => {
          exportSpecs();
        }}
        ><i class="bi bi-download me-1" /> Export as a Dupo file (<code
          >{export_file_name || "export"}.dupo.json</code
        >)</button
      >
    </div>
    <div class="dupo-menu-pane-row description mt-2">
      <p class="text-sm">Export dataset and artbaord data as a single file</p>
    </div>
    <div class="dupo-menu-pane-form-row mt-2">
      <button
        type="button"
        class="menu-second-level"
        on:click={() => {
          exportViews();
        }}
        ><i class="bi bi-download me-1" /> Export views in HTML (<code
          >{export_file_name || "export"}.html</code
        >)</button
      >
    </div>
    <div class="dupo-menu-pane-row description mt-2">
      <p class="text-sm">
        Dupo views are supported only in HTML due to technical details (unable
        to donwload image).
      </p>
    </div>
    <div class="dupo-menu-pane-button-row mt-2">
      <button type="button" on:click={() => cancelSubMenu()}
        ><i class="bi bi-arrow-left me-1" />Cancel</button
      >
    </div>
  </div>
{/if}
